import {FP_DISCLAIMER_TEXT} from '../../models/system.model';

const Disclaimer = () => {
	return <div className="text-center text-gray-500 mb-2 text-xs">{FP_DISCLAIMER_TEXT}</div>;
};

export default Disclaimer;
